import React from 'react';
import { DEFAULT_COLOR } from './shared.jsx';
import {
  Loader01, Loader02, Loader03, Loader04, Loader05,
  Loader06, Loader07, Loader08, Loader09,
} from './css-loaders.jsx';
import {
  Loader10, Loader11, Loader12, Loader13, Loader14,
  Loader15, Loader16, Loader17, Loader18, Loader19, Loader20,
} from './svg-loaders.jsx';

export const ALL_LOADERS = [
  Loader01, Loader02, Loader03, Loader04, Loader05,
  Loader06, Loader07, Loader08, Loader09, Loader10,
  Loader11, Loader12, Loader13, Loader14, Loader15,
  Loader16, Loader17, Loader18, Loader19, Loader20,
];

export default function LoadersShowcase({ color = DEFAULT_COLOR, size = 200 }) {
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: `repeat(auto-fit, ${size}px)`,
        gap: 16,
        justifyContent: 'center',
        padding: '48px 32px 96px',
        background: '#f4f3ef',
        minHeight: '100vh',
        fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
      }}
    >
      {ALL_LOADERS.map((L, i) => (
        <div
          key={i}
          style={{
            position: 'relative',
            width: size,
            height: size,
            display: 'grid',
            placeItems: 'center',
          }}
        >
          <span style={{
            position: 'absolute', top: 8, left: 10,
            fontSize: 10, color: 'rgba(17,17,17,.25)',
            letterSpacing: '.04em',
          }}>
            {String(i + 1).padStart(2, '0')}
          </span>
          <L size={size} color={color} />
        </div>
      ))}
    </div>
  );
}
